/**
 * Как рисовать глиф по id (`collection:name`): solid только если последний сегмент имени
 * (после последнего `-`) — `bold` или `bulk`. Например `text-bold-linear` → linear → outline.
 */
export function defaultFillTypeFromIconName(iconName: string): 'solid' | 'outline' {
  const local = iconName.includes(':')
    ? iconName.slice(iconName.indexOf(':') + 1)
    : iconName
  const last = local.split('-').pop() ?? ''
  const token = last.toLowerCase()
  return token === 'bold' || token === 'bulk' ? 'solid' : 'outline'
}
